import { uniqueKey } from 'global/common/keys'
import { getSectionColor } from 'projectSpecific/sports/create/sectionColors'
import { useSportsMatches } from 'projectSpecific/sports/useHelpers/useSportsMatches'
import React, { useMemo } from 'react'
import { Icon, Label } from 'semantic-ui-react'

export const SectionHeader = ({ levelKey, sectionKey }) => {
  return (
    <div className="match-date-sec sh" key={uniqueKey('mls', 'tm', levelKey, sectionKey)}>
      <div>{_.startCase(sectionKey)}</div>
      {sectionKey && <Label circular size={'tiny'} color={getSectionColor(sectionKey)} />}
    </div>
  )
}

export const LevelHeader = ({ levelKey, matches_level }) => {

  const { getMatchCounts_level } = useSportsMatches()

  const counts = useMemo(() => {
    return getMatchCounts_level({ matches_level })
  }, [matches_level])

  return (
    <div className="level-header header-flexish">
      <div></div>
      <div>{_.startCase(levelKey)}</div>
      <div style={{ display: 'flex' }}>
        {counts.missing > 0 && <Label size='mini' className='miss' title={'Missing'}>{counts.missing}</Label>}
        <Label size='mini' title={'Total'}>{counts.total}</Label>
      </div>
    </div>
  )
}